import React, { Fragment } from "react";
import { List, Datagrid, TextField, EditButton, useListContext, BulkDeleteButton } from "react-admin";
import { Button as MuiButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

const BulkActionButtons = ({ onBulkEdit }) => {
    const { selectedIds } = useListContext();

    return (
        <Fragment>
            <MuiButton onClick={() => onBulkEdit(selectedIds)}>
                <EditIcon />
                Bulk Edit
            </MuiButton>
            <BulkDeleteButton />
        </Fragment>
    );
};

const EdgeConfigList = ({ onBulkEdit, ...props }) => {
    return (
        <List {...props}>
            <Datagrid bulkActionButtons={<BulkActionButtons onBulkEdit={onBulkEdit} />}>
                <TextField source="edge_device_id" />
                <TextField source="serial_no" />
                <TextField source="version_no" />
                <TextField source="priority_group" />
                <TextField source="from" />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export { EdgeConfigList, BulkActionButtons };
